/**
 * Public landing page shown when:
 * - A Google-verified email signs in but has NO pending invitation (gate ON)
 * - An admin-revoked user attempts to sign in
 *
 * No auth required — accessible at /access-denied.
 * Contains NO query-param-driven redirects (open-redirect protection).
 */
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export function AccessDenied(): JSX.Element {
  const { t } = useTranslation(["auth", "common"]);
  const adminEmail = "muhammed.marvan@hightekers.com";

  return (
    <main className="min-h-screen bg-surface flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-surface-2 border border-border rounded-2xl p-8 text-center">
        <div className="w-14 h-14 rounded-full bg-red-soft text-red-text flex items-center justify-center mx-auto mb-4">
          <ShieldAlert className="w-7 h-7" aria-hidden />
        </div>
        <h1 className="text-[18px] font-semibold text-text mb-2">
          {t("auth:access_denied_title", { defaultValue: "Access not authorised" })}
        </h1>
        <p className="text-[14px] text-dim leading-relaxed mb-6">
          {t("auth:access_denied_body", {
            defaultValue:
              "You do not currently have access to Corporate Map. Access is by invitation only. If you believe this is a mistake, contact the administrator.",
          })}
        </p>
        <p className="text-[13px] text-dim mb-6">
          <a
            href={`mailto:${adminEmail}`}
            className="text-accent font-medium hover:underline"
          >
            {adminEmail}
          </a>
        </p>
        <Link
          to="/auth/signin"
          className="inline-block bg-accent text-white rounded-lg px-4 py-2 text-[14px] font-medium hover:bg-[#4338ca] transition-colors"
        >
          {t("auth:access_denied_back", { defaultValue: "Back to sign in" })}
        </Link>
      </div>
    </main>
  );
}

export default AccessDenied;
